import { render } from "./TimooOverview.vue?vue&type=template&id=60ecb33d&scoped=true"
import script from "./TimooOverview.vue?vue&type=script&lang=js"
export * from "./TimooOverview.vue?vue&type=script&lang=js"

import "./TimooOverview.vue?vue&type=style&index=0&id=60ecb33d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ecb33d"]])

export default __exports__